import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Transactions from "@/pages/Transactions";
import Apps from "@/pages/Apps";
import Cash from "@/pages/Cash";
import Expenses from "@/pages/Expenses";
import Debts from "@/pages/Debts";
import Customers from "@/pages/Customers";
import Titipan from "@/pages/Titipan";
import Reconciliation from "@/pages/Reconciliation";
import Reports from "@/pages/Reports";
import AIInsights from "@/pages/AIInsights";
import Settings from "@/pages/Settings";
import Notifications from "@/pages/Notifications";
import ImportGopay from "@/pages/ImportGopay";
import SharedReport from "@/pages/SharedReport";
import { Toaster } from "@/components/ui/sonner";
import { ConfirmRoot } from "@/lib/confirm";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/laporan/:token" element={<SharedReport />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="/transactions" element={<Transactions />} />
              <Route path="/apps" element={<Apps />} />
              <Route path="/cash" element={<Cash />} />
              <Route path="/expenses" element={<Expenses />} />
              <Route path="/debts" element={<Debts />} />
              <Route path="/customers" element={<Customers />} />
              <Route path="/titipan" element={<Titipan />} />
              <Route path="/reconciliation" element={<Reconciliation />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/ai" element={<AIInsights />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/notifications" element={<Notifications />} />
              <Route path="/import-gopay" element={<ImportGopay />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <ConfirmRoot />
      </AuthProvider>
    </div>
  );
}

export default App;
